"use client"

import { Form, Badge } from "react-bootstrap"

const SuitabilityFilter = ({ value, onChange, totalCrops, filteredCrops }) => {
  const handleChange = (e) => {
    onChange(Number(e.target.value))
  }

  const getFilterColor = () => {
    if (value >= 80) return "success"
    if (value >= 60) return "warning"
    if (value >= 40) return "info"
    return "secondary"
  }

  return (
    <div className="d-flex align-items-center gap-3">
      <div className="d-flex align-items-center gap-2">
        <Form.Label className="mb-0 text-nowrap small fw-medium">Min Suitability:</Form.Label>
        <Form.Range
          min="0"
          max="100"
          step="10"
          value={value}
          onChange={handleChange}
          style={{ width: "120px" }}
          className="form-range-sm"
        />
        <Badge bg={getFilterColor()} className="rounded-pill">
          {value}%+
        </Badge>
      </div>

      <div className="text-muted small">
        <span className="fw-medium">{filteredCrops}</span>
        <span className="text-muted">/{totalCrops} crops</span>
      </div>
    </div>
  )
}

export default SuitabilityFilter
